import type { User } from '@supabase/supabase-js';

const DEMO_EMAIL_DOMAIN_ALLOWLIST = ['shadowscan.com.au'];

export const isDemoEmailAllowed = (email?: string | null) => {
  if (!email) return false;
  const normalized = email.toLowerCase();
  return DEMO_EMAIL_DOMAIN_ALLOWLIST.some((domain) => normalized.endsWith(`@${domain}`));
};

export const isDemoUserAllowed = (user: User | null) => {
  if (!user) return false;
  if (user.user_metadata?.is_internal === true) return true;
  if (user.user_metadata?.demo_access === true) return true;
  return isDemoEmailAllowed(user.email);
};
